import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import IdentifyContactBadge from '../../visitor-identification/components/IdentifyContactBadge';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "KnownVisitorContactInfo__Wrapper",
  componentId: "sc-35bqw1-0"
})(["display:flex;align-items:center;width:100%;overflow:hidden;"]);
const formatJobTitleAndCompany = (jobTitle, company) => {
  if (jobTitle && company) return `${jobTitle} @ ${company}`;
  return jobTitle || company || null;
};
const EmptyIcon = () => /*#__PURE__*/_jsx("span", {});
EmptyIcon.displayName = 'EmptyIcon';
const KnownVisitorContactInfo = ({
  company,
  contactLink,
  jobTitle,
  name,
  onContactLinkClick,
  shouldDisplayIdentifyBadge
}) => {
  const subtitle = formatJobTitleAndCompany(jobTitle, company);
  return /*#__PURE__*/_jsx(Wrapper, {
    "data-test-id": "known-contact-info-highlight",
    children: /*#__PURE__*/_jsxs("div", {
      className: "width-100",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "align-center",
        children: [shouldDisplayIdentifyBadge && /*#__PURE__*/_jsx("span", {
          className: "m-right-1",
          children: /*#__PURE__*/_jsx(IdentifyContactBadge, {})
        }), /*#__PURE__*/_jsx(UILink, {
          href: contactLink,
          onClick: onContactLinkClick,
          external: true,
          ExternalIcon: EmptyIcon,
          children: /*#__PURE__*/_jsxs("span", {
            className: "justify-start",
            children: [/*#__PURE__*/_jsx(UITruncateString, {
              children: name
            }), /*#__PURE__*/_jsx(UIIcon, {
              name: "externalLink",
              className: "m-left-1"
            })]
          })
        })]
      }), subtitle && /*#__PURE__*/_jsx(UITruncateString, {
        children: subtitle
      })]
    })
  });
};
KnownVisitorContactInfo.displayName = 'KnownVisitorContactInfo';
export default KnownVisitorContactInfo;